var section = $('.cevoid-section');

if(section.length > 0) {
    $("#cevoid-container").on("DOMSubtreeModified.lo", function() {
        if($(this).find('.cevoid-grid').length > 0) {
            section.addClass('is-active');
            $("#cevoid-container").off("DOMSubtreeModified.lo");
        }
    });
}